import React from "react";
import { Star } from "lucide-react";

// A /10 rating shown as five stars (half steps) plus the number.
const Rating = ({ value, size = 16 }) => {
  const rating = Math.max(0, Math.min(10, Number(value) || 0));
  const full = Math.floor(rating / 2);
  const half = rating % 2 !== 0;

  return (
    <div className="flex items-center gap-3" aria-label={`Rated ${rating} out of 10`} role="img">
      <div className="flex gap-0.5" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span key={i} className="relative inline-flex">
            <Star size={size} strokeWidth={1.75} className="text-slate-700" />
            {(i < full || (i === full && half)) && (
              <Star
                size={size}
                strokeWidth={1.75}
                className="absolute inset-0 fill-current text-sky-400"
                style={i === full && half ? { clipPath: "inset(0 50% 0 0)" } : undefined}
              />
            )}
          </span>
        ))}
      </div>
      <span className="font-mono text-sm text-slate-300" aria-hidden="true">
        {rating}/10
      </span>
    </div>
  );
};

export default Rating;
